import ContentItem from './ContentItem';
import { PlayType } from '../../common/constants';

/**
 * Return the PlayType for a list of Content Items.
 *
 * @param items - List of content items
 * @returns First PlayType found in content items or PlayType.UNKNOWN
 */
export default function getPlayTypeFromContentItems(
  items: ContentItem[]
): PlayType {
  const data = items
    .map(item => item.data)
    .find(data => {
      return data && data.playType;
    });
  return (data && data.playType) || PlayType.UNKNOWN;
}
